<ul
    [id]="id + '-tag-list'"
    class="sh-tag-list"
    [class.sh-form-tag-list__list]="styling.style !== 'Embedded'"
    [class.sh-form-tag-list__list--inline-input]="styling.style === 'Embedded'"
>
    @for (tag of tags(); let i = $index; track tag.value) {
        @if (currentTagEditIndex() !== i) {
            <li
                #tagItem
                [id]="_tagIdPrefix + '-' + i"
                [tabindex]="i === 0 ? 0 : -1"
                class="sh-tag sh-tag-list__item"
                [class]="styling.color"
                [title]="tag.value"
                [class.-sh-truncate]="styling.truncate"
                [class.sh-tag--readonly]="disabled()"
                [class.-sh-editable]="editable()"
                (click)="onEditMode(i, tag.value)"
                (keyup.enter)="onEditMode(i, tag.value)"
                (keyup.space)="onEditMode(i, tag.value)"
                (keyup.delete)="removeTag(tag.value)"
                (keyup.backspace)="removeTag(tag.value)"
                (focus)="onFocus(_tagIdPrefix + '-' + i)"
                (focusout)="onFocusOut()"
            >
                <span class="sh-tag__label">{{ tag.value }}</span>
                @if (!disabled()) {
                    @if (editable() && !limitedButtons()) {
                        <button
                            [tabindex]="-1"
                            [id]="id + '-tag-list-tag-' + i + '-edit-action'"
                            [title]="_labels.editTooltip | translate"
                            type="button"
                            class="sh-tag__button"
                            (click)="onEditMode(i, tag.value, $event)"
                            (focus)="onFocus(_tagIdPrefix + '-' + i)"
                        >
                            <svg sh-icon [name]="'edit'" [size]="sizes.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
                        </button>
                    }
                    <button
                        [tabindex]="-1"
                        [id]="id + '-tag-list-tag-' + i + '-remove-action'"
                        [title]="_labels.removeTooltip | translate"
                        type="button"
                        class="sh-tag__button"
                        (click)="removeTag(tag.value, $event)"
                        (focus)="onFocus(_tagIdPrefix + '-' + i)"
                    >
                        <svg sh-icon [name]="'delete'" [size]="sizes.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
                    </button>
                }
            </li>
        } @else {
            <div #tagItem class="sh-tag-list__edit-item__container">
                <input
                    shDynamicResize
                    type="text"
                    class="sh-tag sh-tag-list__item sh-tag-list__edit-item__input"
                    [formControl]="tagEditFormControl"
                    [shAutoFocus]="true"
                    [shClickOutsideFocusEvent]="'focusin'"
                    (shClickOutside)="onSubmitTagEditChange()"
                    (keyup.escape)="onEscape()"
                    (keyup.enter)="onSubmitTagEditChange()"
                />
                @if (!disabled() && !limitedButtons()) {
                    <button
                        [tabindex]="-1"
                        [id]="id + '-tag-list-tag-' + i + '-confirm-action'"
                        [title]="_labels.confirmTooltip | translate"
                        type="button"
                        class="sh-tag__button sh-tag-list__edit-item__action"
                        (click)="onSubmitTagEditChange($event)"
                    >
                        <svg sh-icon [name]="'check'" [size]="sizes.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
                    </button>
                }
            </div>
        }
    }
    @if (styling.style === "Embedded") {
        <ng-content select="[embeddedInput]"></ng-content>
    }
</ul>
